import { cn } from "../../lib/utils";

function Separator(props: React.HTMLAttributes<HTMLDivElement>) {
	return (
		<div
			{...props}
			className={cn("w-full border-t border-gray-200 my-5", props.className)}
		/>
	);
}

export { Separator };
